import { RootState } from "redux/rootReducer";

export const selectIsRegisteringPatient = (state: RootState) =>
  state.patientRegistration.loading;
export const selectPatientRegistrationErrorMessage = (state: RootState) =>
  state.patientRegistration.error;
export const patientRegistrationDataResponse = (state: RootState) =>
  state.patientRegistration.patientRegistrationResponse;
